// Returns YYYY-MM-DD in local time (en-CA locale produces ISO-8601 date format).
export function formatISODate(value) {
  const date = parseDate(value);
  if (!date) return "";
  return date.toLocaleDateString("en-CA");
}

// Returns a human-readable date+time string: "Jan 15, 2024, 2:30 PM".
export function formatDateTime(value, { fallback = "\u2014" } = {}) {
  const date = parseDate(value);
  if (!date) return fallback;
  try {
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    }).format(date);
  } catch (err) {
    console.error(err);
    return fallback;
  }
}

export function parseDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatRelativeTime(value, { fallback = null } = {}) {
  const date = parseDate(value);
  if (!date) return fallback;

  const diffMs = Date.now() - date.getTime();
  if (diffMs < 0) return "Just now";

  const diffMinutes = Math.floor(diffMs / 60000);
  if (diffMinutes < 1) return "Just now";
  if (diffMinutes < 60) {
    const minutes = Math.max(diffMinutes, 1);
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) {
    return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
  }

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 30) {
    return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
  }

  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths < 12) {
    return `${diffMonths} month${diffMonths === 1 ? "" : "s"} ago`;
  }

  const diffYears = Math.floor(diffMonths / 12);
  return `${diffYears} year${diffYears === 1 ? "" : "s"} ago`;
}

